// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"361":"13004038","801":"49878819","845":"745b2b5c"}[chunkId] + ".chunk.js";
};